export const ImmutableJSRecordMethodNames = [
  'asImmutable',
  'asMutable',
  'butLast',
  'chain',
  'clear',
  'concat',
  'contains',
  'count',
  'countBy',
  'delete',
  'deleteIn',
  'entries',
  'entrySeq',
  'equals',
  'every',
  'filter',
  'filterNot',
  'find',
  'findEntry',
  'findKey',
  'findLast',
  'findLastEntry',
  'findLastKey',
  'first',
  'flatMap',
  'flatten',
  'flip',
  'forEach',
  'fromEntrySeq',
  'get',
  'getIn',
  'groupBy',
  'has',
  'hasIn',
  'hashCode',
  'includes',
  'inspect',
  'isEmpty',
  'isSubset',
  'isSuperset',
  'join',
  'keyOf',
  'keySeq',
  'keys',
  'last',
  'lastKeyOf',
  'map',
  'mapEntries',
  'mapKeys',
  'max',
  'maxBy',
  'merge',
  'mergeDeep',
  'mergeDeepIn',
  'mergeDeepWith',
  'mergeIn',
  'mergeWith',
  'min',
  'minBy',
  'reduce',
  'reduceRight',
  'remove',
  'removeIn',
  'rest',
  'reverse',
  'set',
  'setIn',
  'size',
  'skip',
  'skipLast',
  'skipUntil',
  'skipWhile',
  'slice',
  'some',
  'sort',
  'sortBy',
  'take',
  'takeLast',
  'takeUntil',
  'takeWhile',
  'toArray',
  'toIndexedSeq',
  'toJS',
  'toJSON',
  'toKeyedSeq',
  'toList',
  'toMap',
  'toObject',
  'toOrderedMap',
  'toOrderedSet',
  'toSeq',
  'toSet',
  'toSetSeq',
  'toSource',
  'toStack',
  'update',
  'updateIn',
  'valueSeq',
  'values',
  'wasAltered',
  'withMutations',
];
